import { useContext, useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import AppContext from "../contexts/appContext";
import { Helmet } from "react-helmet";
import HowItWorksDynamic from "../components/HowItWorksDynamic";
import FAQDynamic from "./FAQDynamic";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import { getServicePage } from "../services/getServicePages";
import ClientsReviews from "../components/ClientsReviews";
import MenuTables from "../components/MenuTables";
export default function Service() {
  const { menu } = useContext(AppContext);

  const { serviceId, categoryId, subCategory } = useParams();
  const [serviceData, setServiceData] = useState();
  const [error, setError] = useState("");
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const menuService = useMemo(() => {
    if (menu) {
      return menu?.find((ser) => ser.id == serviceId);
    }
    return null;
  }, [menu, serviceId]);

  const services = useMemo(() => {
    if (menu) {
      const menuService = menu?.filter((ser) => ser.id == serviceId)[0]?.category;
      if (menuService) {
        return menuService;
      }
      return null;
    }
    return null;
  }, [menu, serviceId]);

  const menuCategories = useMemo(() => {
    if (services) {
      const mainMenuCategory = services?.filter((cat) => cat.id == categoryId)[0]?.subcategory;
      if (mainMenuCategory) {
        return mainMenuCategory;
      }
      return null;
    }
    return null;
  }, [services, categoryId]);

  const menuSubCategory = useMemo(() => {
    const mainMenuSubCategory = menuCategories?.filter((subCat) => subCat.id == subCategory)[0]
      ?.itemId;
    if (mainMenuSubCategory) {
      return mainMenuSubCategory;
    }
    return null;
  }, [menuCategories, subCategory]);

  const mainRoute = useMemo(() => {
    if (menu) {
      const route = `/getstarted/${menuService?.name.toLowerCase()}/${serviceId}/${categoryId}`; ///${subCategory}`;
      if (route) {
        return route;
      }
      return null;
    }
    return null;
  }, [menu, serviceId, categoryId, subCategory]);

  const serviceSubCategorySortedMenuItems = useMemo(() => {
    if (menuCategories) {
      return menuCategories[0]?.menuItem?.sort((a, b) => a.id - b.id);
    }
    return null;
  }, [menuCategories]);

  React.useEffect(() => {
    if (menuCategories && menuCategories.length > 0) {
      setIsLoading(true);
      getServicePage(menuCategories[0]?.serviceDynamicContentId, "")
        .then((response) => {
          setServiceData(response.data);
          setHasError(false);
        })
        .catch((error) => {
          setHasError(true);
          setError("Invalid fetching, please try again");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [menuCategories]);

  const serviceFieldsMap = useMemo(() => {
    const sortByOrder = (a, b) => a.order > b.order;
    let categoryServiceFieldsMap = {
      whyus: [],
      benefits: [],
      faq: [],
      amplify: [],
    };
    if (serviceData?.serviceFields) {
      serviceData?.serviceFields.map((field) => {
        if (!field.order) {
          field.order =
            categoryServiceFieldsMap[field.category.toLowerCase()].length > 0
              ? categoryServiceFieldsMap[field.category.toLowerCase()].length + 1
              : 1;
        }
        categoryServiceFieldsMap[field.category.toLowerCase()].push(field);
      });
      categoryServiceFieldsMap["whyus"] = categoryServiceFieldsMap["whyus"].sort(sortByOrder);
      categoryServiceFieldsMap["benefits"] = categoryServiceFieldsMap["benefits"].sort(sortByOrder);
      categoryServiceFieldsMap["faq"] = categoryServiceFieldsMap["faq"].sort(sortByOrder);
      categoryServiceFieldsMap["amplify"] = categoryServiceFieldsMap["amplify"].sort(sortByOrder);
    }
    return categoryServiceFieldsMap;
  }, [serviceData?.serviceFields]);

  const splitContent = (text) => {
    // Define the split pattern, e.g., by double new lines or specific markers
    const sections = text.split("</p>").filter(Boolean);
    return sections;
  };
  const contentSections = splitContent(serviceData?.subSubTitle || "High-Quality");
  const shouldRenderTable = contentSections.length === 4 || contentSections.length === 6;

  return (
    <>
      <Helmet>
        <title>Dailysocialboost | Services</title>
      </Helmet>
      <section className="container my-24 mb-6 mx-auto px-24 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold">
          <div className="text-purple-650">
            <span dangerouslySetInnerHTML={{ __html: serviceData?.title }}></span>
          </div>
        </h2>
        <div
          className="my-10 font-semibold"
          dangerouslySetInnerHTML={{ __html: serviceData?.subTitle }}
        ></div>
        <MenuTables
          menu={menu}
          serviceId={serviceId}
          categoryId={categoryId}
          mainRoute={mainRoute}
        />
      </section>

      {shouldRenderTable && (
        <section className="container mx-auto px-5 md:px-24 text-center">
          <table className="min-w-full divide-y divide-gray-300 mt-20 mb-20 table-fixed">
            <thead>
              <tr>
                <th
                  dangerouslySetInnerHTML={{ __html: contentSections[0] }}
                  className={`px-6 py-3 text-center text-md font-medium border border-gray-300 uppercase tracking-wider w-1/2 
                    ${contentSections.length === 6 ? "w-1/3" : ""}
                    `}
                ></th>
                <th
                  dangerouslySetInnerHTML={{ __html: contentSections[2] }}
                  className={`px-6 py-3 text-center text-md font-medium border border-gray-300 uppercase tracking-wider w-1/2 
                    ${contentSections.length === 6 ? "w-1/3" : ""}
                    `}
                ></th>
                {contentSections.length === 6 && (
                  <th
                    dangerouslySetInnerHTML={{ __html: contentSections[4] }}
                    className={`px-6 py-3 text-center text-md font-medium border border-gray-300 uppercase tracking-wider w-1/2 
                      ${contentSections.length === 6 ? "w-1/3" : ""}
                      `}
                  ></th>
                )}
              </tr>
            </thead>
            <tbody className="text-center text-gray-500 tracking-wider">
              <tr>
                <td
                  className={`p-4 border border-gray-300 transition-all duration-200 hover:bg-pink-200 w-1/2 ${
                    contentSections.length === 6 ? "w-1/3" : ""
                  }`}
                  dangerouslySetInnerHTML={{ __html: contentSections[1] }}
                ></td>
                <td
                  className={`p-4 border border-gray-300 transition-all duration-200 hover:bg-pink-200 w-1/2 ${
                    contentSections.length === 6 ? "w-1/3" : ""
                  }`}
                  dangerouslySetInnerHTML={{ __html: contentSections[3] }}
                ></td>
                {contentSections.length === 6 && (
                  <td
                    className={`p-4 border border-gray-300 transition-all duration-200 hover:bg-pink-200 w-1/2 ${
                      contentSections.length === 6 ? "w-1/3" : ""
                    }`}
                    dangerouslySetInnerHTML={{ __html: contentSections[5] }}
                  ></td>
                )}
              </tr>
            </tbody>
          </table>
        </section>
      )}
      <section className="container mx-auto px-5 md:px-24 text-center">
        <div
          className="my-10 font-semibold"
          dangerouslySetInnerHTML={{ __html: serviceData?.stepTitle }}
        ></div>
        <div className="my-10 " dangerouslySetInnerHTML={{ __html: serviceData?.stepSub }}></div>
      </section>
      <HowItWorksDynamic serviceData={serviceData} />
      <ClientsReviews />
      <section className="container my-5 mx-auto px-5 md:px-24 text-center">
        <h2 className="mt-2 mb-14 text-center text-3xl font-bold text-pink-350">Why us?</h2>
        <div className="flex flex-col md:flex-row mt-8">
          {serviceFieldsMap["whyus"]?.map((question, idx) => (
            <div id={idx} className="flex flex-col gap-3 mt-8 basis-full">
              <h3
                className="pb-4 text-xl font-semibold"
                dangerouslySetInnerHTML={{ __html: question.title }}
              ></h3>
              <p
                className="pb-8 text-xl text-center"
                dangerouslySetInnerHTML={{ __html: question.content }}
              ></p>
            </div>
          ))}
        </div>
      </section>
      <section className="container my-5 mx-auto px-5 md:px-24 text-center">
        <div>
          {serviceFieldsMap["benefits"]?.map((question, idx) => (
            <div>
              <div
                className="pb-4 text-xl font-semibold"
                dangerouslySetInnerHTML={{ __html: question.title }}
              ></div>
              <div
                className="pb-8 text-xl text-center"
                dangerouslySetInnerHTML={{ __html: question.content }}
              ></div>
            </div>
          ))}
        </div>
      </section>
      <section className="container my-5 mx-auto px-5 md:px-24">
        <FAQDynamic faqs={serviceFieldsMap["faq"]} />
      </section>
      <section className="container mx-auto px-5 md:px-28">
        <div className="" dangerouslySetInnerHTML={{ __html: serviceData?.faqTitle }}></div>
      </section>
      <section>
        <div className="flex flex-col items-center self-center">
          <div className="my-16">
            <Link
              reloadDocument
              className={`inline-block px-12 py-5 uppercase rounded-3xl text-white bg-purple-650
             hover:opacity-90 transition-all`}
              to={`${mainRoute}/${subCategory[0]}/${
                serviceSubCategorySortedMenuItems ? serviceSubCategorySortedMenuItems[0]?.id : 1
              }/${menuSubCategory}`}
            >
              Buy {services ? services?.filter((x) => x?.id == categoryId)[0]?.name : ""} Now
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
